import React from 'react'
import { useTranslation } from 'react-i18next'

const QuantumOddsCTA = () => {
  const { t } = useTranslation()
  return (
  <p className="oracle-quantum-cta">
    {t('oracleChat.ctaLead')} <a href="https://quantumodds.xyz/" target="_blank" rel="noopener noreferrer">{t('oracleChat.ctaLink')} ↗</a>
  </p>
  )
}

export default QuantumOddsCTA
